
import * as React from "react"
import { Typography, type TypographyProps } from "./base"

// Heading variants
export const H1 = React.forwardRef<HTMLHeadingElement, Omit<TypographyProps, "as">>(
  ({ className, size = "h1", weight = "bold", ...props }, ref) => (
    <Typography
      ref={ref}
      as="h1"
      size={size}
      weight={weight}
      className={className}
      {...props}
    />
  )
)
H1.displayName = "H1"

export const H2 = React.forwardRef<HTMLHeadingElement, Omit<TypographyProps, "as">>(
  ({ className, size = "h2", weight = "bold", ...props }, ref) => (
    <Typography
      ref={ref}
      as="h2"
      size={size}
      weight={weight}
      className={className}
      {...props}
    />
  )
)
H2.displayName = "H2"

export const H3 = React.forwardRef<HTMLHeadingElement, Omit<TypographyProps, "as">>(
  ({ className, size = "h3", weight = "semibold", ...props }, ref) => (
    <Typography
      ref={ref}
      as="h3"
      size={size}
      weight={weight}
      className={className}
      {...props}
    />
  )
)
H3.displayName = "H3"

export const H4 = React.forwardRef<HTMLHeadingElement, Omit<TypographyProps, "as">>(
  ({ className, size = "h4", weight = "semibold", ...props }, ref) => (
    <Typography
      ref={ref}
      as="h4"
      size={size}
      weight={weight}
      className={className}
      {...props}
    />
  )
)
H4.displayName = "H4"
